import type { InsuranceIndex } from '../../../types/InsuranceFeatureConfig';
import type { BillProtectionFeatureConfig } from '../../../types/insurances/BillProtectionFeatureConfig';
import { billProtection as base } from './base';
import { billProtection as RO } from './RO';

export const billProtectionConfig: InsuranceIndex<BillProtectionFeatureConfig> = { base, RO };
